import { useState, ReactNode } from "react";

// material ui
import { Typography } from "@mui/material";

// material-ui icons

// project import
import { useTranslation } from "utils/locales/utilityFunctions";
import FormDialog from "components/dialogs/FormDialog";

type InputAProps = {
  title: string;
  tabs?: React.ReactNode;
  titleChip?: string;
  titleChipTooltip?: string;
  open: boolean;
  children: ReactNode;
  showDotMenu?: boolean;
  dotMenuItems?: { text: string; fcn: (e: any) => any; props?: any }[];
  buttonText: string;
  sectionHeader?: string;
  captionText?: string;
  saveDisabled?: boolean;
  cancelDisabled?: boolean;
  errorText?: string;
  loading?: boolean;
  hideBackdrop?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  allowDocking?: boolean;
  handleClose: () => void;
  handleSave: () => void;
  toggleDocking?: (state: boolean) => void;
};

const SingleColumnInput = ({
  title,
  titleChip,
  titleChipTooltip,
  open,
  children,
  showDotMenu,
  dotMenuItems,
  buttonText,
  sectionHeader,
  captionText,
  saveDisabled,
  cancelDisabled,
  errorText,
  loading,
  hideBackdrop,
  maxWidth,
  allowDocking,
  tabs,
  handleClose,
  handleSave,
  toggleDocking,
}: InputAProps) => {
  // --- Hooks --- //
  const { translate } = useTranslation();

  // --- State --- //
  const [openNestedDialog, setOpenNestedDialog] = useState(false);

  // --- Handles --- //
  const handleCloseInput = () => {
    // If data has been changed and the user needs to accept that it will be lost if the user carry on
    if (false) {
      setOpenNestedDialog(true);
    } else {
      handleClose();
    }
  };

  const handleClickNestedDialog = () => {
    setOpenNestedDialog(false);
  };

  const handleCancelNestedDialog = (action: string) => {
    setOpenNestedDialog(false);
    handleClose();
  };

  // --- Functions --- //
  const handleSaveInput = () => {
    handleSave();
  };

  let newMaxWidth = "xs" as "xs" | "sm" | "md" | "lg" | "xl" | false;
  if (maxWidth) newMaxWidth = maxWidth;

  return (
    <FormDialog
      open={open}
      title={title}
      tabs={tabs}
      titleChip={titleChip}
      titleChipTooltip={titleChipTooltip}
      onClickText={buttonText}
      onCancelText={translate("area-close-button-text")}
      onClick={handleSaveInput}
      onCancel={handleCloseInput}
      maxWidth={newMaxWidth}
      openNestedDialog={openNestedDialog}
      onClickNestedDialog={handleClickNestedDialog}
      onCancelNestedDialog={() => handleCancelNestedDialog("cancled")}
      showDotMenu={showDotMenu}
      dotMenuItems={dotMenuItems}
      saveDisabled={saveDisabled}
      cancelDisabled={cancelDisabled}
      captionText={captionText}
      errorText={errorText}
      loading={loading}
      hideBackdrop={hideBackdrop}
      allowDocking={allowDocking}
      toggleDocking={toggleDocking}
    >
      <>
        <Typography variant="h5" sx={{ mb: 0 }}>
          {sectionHeader}
        </Typography>

        {children}
      </>
    </FormDialog>
  );
};

export default SingleColumnInput;
